$(document).bind('_js_ready', function () {
	let breakpoint;

	if($('#home').length !== 0) {
		 breakpoint = 800;
	} else {
		breakpoint = 1220;
	}

    $('#alaune .small_item_container').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		// ///////// Conf pour arrow prev / next
		prevArrow:"<button type='button' aria-label='Précédent' title='Précédent' class='slick-prev slick-arrow'><span class='show-for-sr'>Précédent</span></button>",
		nextArrow:"<button type='button' aria-label='Suivant' title='Suivant' class='slick-next slick-arrow'><span class='show-for-sr'>Suivant</span></button>",
		responsive: [
			{
				breakpoint: breakpoint,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 640,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
});